import { DecimalPipe } from '@angular/common';
import { AfterViewInit, Component, Input, OnChanges } from '@angular/core';
import { Chart } from 'chart.js';

@Component({
  standalone: false,
  selector: 'app-avc-credit-line-chart',
  templateUrl: './avc-credit-line-chart.component.html',
  styleUrls: ['./avc-credit-line-chart.component.scss'],
  providers: [DecimalPipe]
})
export class AvcCreditLineChartComponent implements AfterViewInit, OnChanges {
  @Input()
  data: CreditLineChartInput[];

  availableLabel = $localize`:@@amadeus-direct.avc-credit-line.available:Available`;
  spentLabel = $localize`:@@amadeus-direct.avc-credit-line.spent:Spent`;


  chart: any;

  public config: any = {
    type: 'doughnut',
    data: {
      labels: ['Used', 'Available'],
      datasets: [
        {
          cutout: '85%',
          data: [0.5, 0.5],
          backgroundColor: ['rgb(0, 8, 53, 1)', 'rgb(58, 139, 255, 1)'],
          hoverOffset: 400,
          radius: 100
        }
      ]
    },
    options: {
      responsive: true,
      tooltips: {
        caretPadding: 30,
        displayColors: false,
        callbacks: {
          label: (tooltipItem, data) => {
            const currentLabel = data.labels[tooltipItem.index].trim();
            let labelToDisplay = '';
            if (currentLabel.indexOf(this.availableLabel) !== -1) {
              labelToDisplay = this.availableLabel;
            } else {
              labelToDisplay = this.spentLabel;
            }
            return `${this.decimalPipe.transform(this.data[tooltipItem.index].amount, '1.2-2')} ${
              this.data[tooltipItem.index].currency
            } ${labelToDisplay}`;
          }
        }
      },
      showAllTooltips: true,
      title: {
        display: true
      },
      cutout: '85%',
      aspectRatio: 1.45,
      plugins: [
        {
          legend: {
            display: false,
            position: 'bottom',
            onClick: () => {},
            labels: {
              usePointStyle: true,
              pointStyle: 'circle',
              padding: 40
            }
          }
        }
      ]
    }
  };

  constructor(private readonly decimalPipe: DecimalPipe) {}

  ngAfterViewInit(): void {
    this.config.data.labels = this.data.map(
      entry => entry.label + '                                                            '
    );
    this.config.data.datasets[0].data = this.data.map(entry => entry.amount);

    Chart.defaults.doughnut.legend.align = 'start';
    Chart.defaults.doughnut.legend.position = 'bottom';
    Chart.defaults.doughnut.cutoutPercentage = 75;
    Chart.defaults.doughnut.legend.labels.usePointStyle = true;
    Chart.defaults.doughnut.legend.labels.pointStyle = 'circle';
    Chart.defaults.doughnut.legend.labels.padding = 10;
    Chart.defaults.doughnut.legend.onClick = () => {};

    Chart.defaults.doughnut.legend.maxWidth = '80px';

    this.chart = new Chart('credit-line-doughnut', this.config);
  }

  ngOnChanges(): void {
    if (this.chart) {
      this.chart.data.datasets[0].data = this.data.map(item => item.amount);
      this.chart.update();
    }
  }
}

export interface CreditLineChartInput {
  amount: number;
  currency: string;
  label: string;
}
